export const appShellLayoutSx = {
  minHeight: '100vh',
  bgcolor: 'background.default',
  p: 1,
  display: 'flex',
  gap: 0.5,
  alignItems: 'stretch',
  overflow: 'hidden',
}
